export default __webpack_public_path__ + "static/media/Emporika_entypa.38caccfd.jpg";